"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthRoleEntityNameRegex = void 0;
exports.AuthRoleEntityNameRegex = /^[a-zA-Z][\w-]*[a-zA-Z0-9]$/;
//# sourceMappingURL=utils.js.map